import { FlexRow, StyledButton } from '@gorila-shared-ui/components';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  canSubmit: boolean;
  loading: boolean;
  onSubmit: () => void;
  onCancel?: () => void;
  editMode?: boolean;
  submitText?: string;
};

export function FormActionsRow({
  canSubmit,
  loading,
  onSubmit,
  onCancel,
  editMode = false,
  submitText,
}: Readonly<Props>) {
  const { classes, theme } = useStyles();

  if (!submitText) {
    submitText = editMode ? 'Actualizar' : 'Crear';
  }

  return (
    <FlexRow classNames={classes.centeredEnd}>
      <FlexRow gap={theme.sizing.scale300}>
        {onCancel && (
          <StyledButton
            onClick={onCancel}
            kind="tertiary"
          >
            Cancelar
          </StyledButton>
        )}
        <StyledButton
          onClick={onSubmit}
          isLoading={loading}
          disabled={!canSubmit}
        >
          {submitText}
        </StyledButton>
      </FlexRow>
    </FlexRow>
  );
}
